<template>
  <section>
    <div class="px-4 py-5 sm:px-6">
      <h3 class="text-lg font-medium leading-6 text-gray-900">
        Deine Experimente
      </h3>
      <p class="mt-1 max-w-2xl text-sm text-gray-500">
        Experimente, die für deinen Podcast zu dieser Methode angelegt wurden.
      </p>
    </div>
    <article v-if="empty" class="border-t border-gray-200 px-4 py-5 sm:p-0">
      <div class="px-4 py-5 sm:px-6">
        <p class="mt-1 max-w-2xl text-sm text-gray-500">
          Für diese Methode hast du noch kein Experiment angelegt.
        </p>
      </div>
    </article>
    <article v-else="empty" class="border-t border-gray-200 px-4 py-5 sm:p-0">
      <ul role="list" class="divide-y divide-gray-200">
        <li v-for="experiment in results" :key="experiment.id">
          <router-link :to="{name: 'experiments.show', params: {id: experiment.id}}" class="block hover:bg-gray-50">
            <div class="flex items-center px-4 py-4 sm:px-6">
              <div class="min-w-0 flex-1 flex items-center">
                <div class="flex-shrink-0">
                  <div class="flex justify-center items-center w-12 h-12">
                    <Twemoji :code="experiment.practice.emoji" class="w-12 h-12" />
                  </div>
                </div>
                <div class="min-w-0 flex-1 px-4 md:grid md:grid-cols-1 md:gap-4">
                  <div>
                    <p class="text-sm font-medium text-teal-600 truncate">
                      {{ experiment.title }}
                    </p>
                    <p class="mt-2 flex items-center text-sm text-gray-500">
                      <span class="truncate">
                        Angelegt von {{ experiment.user.name }}
                      </span>
                    </p>
                  </div>
                </div>
              </div>
              <div>
                <ChevronRightIcon class="h-5 w-5 text-gray-400" aria-hidden="true" />
              </div>
            </div>
          </router-link>
        </li>
      </ul>
    </article>
  </section>
</template>

<script setup>
import { computed, onMounted, watch } from 'vue';
import { useStore } from 'vuex';
import { useFetchResources } from '@/client/actions';

const props = defineProps({practice: Object});
const store = useStore();

const parent = computed(() => props.practice.id);
const context = computed(() => store.getters['context/context'].id);
const target = computed(() => '/api/podcasts/' + context.value + '/experiments');
const params = computed(() => ({origin: parent.value}));
const action = useFetchResources(target, params.value);

const { results, fetch, fetching, empty } = action;

const mounted = onMounted(fetch);
const parentWatcher = watch(parent, fetch);
const contextWatcher = watch(context, fetch);
</script>
